import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { MonthlyDetails } from '../../../types/PricingAnalysis.types';
import moment from 'moment';
import { RootState } from '../../../store';

const useDollarsLostByPricingConcernSummary = () => {
    const { pricingAnalysisToolSet } = useSelector(
        (state: RootState) => state.pricingAnalysisTool
    );
    const [chartData, setChartData] = useState([]);

    useEffect(() => {
        if (
            !pricingAnalysisToolSet.activeCumulativeSummaryIsLoading &&
            pricingAnalysisToolSet.activeCumulativeSummary
        ) {
            setChartData(
                pricingAnalysisToolSet.activeCumulativeSummary.monthlyDetails.map(
                    (detail: MonthlyDetails) => {
                        return {
                            fromDate: moment(detail.asOfDate).format(
                                'MM/DD/YYYY'
                            ),
                            'Outdated Pricing': -Number(
                                detail.outdatedPricingDollarsLost
                            ),
                            'Pricing Lag': -Number(
                                detail.pricingLagDollarsLost
                            ),
                            'Below Average Margin': -Number(
                                detail.belowAverageMarginDollarsLost
                            ),
                            'Margin Below Goal': -Number(
                                detail.marginBelowGoalDollarsLost
                            ),
                            'Price Below Average': -Number(
                                detail.belowAveragePriceDollarsLost
                            ),
                        };
                    }
                )
            );
        }
    }, [
        pricingAnalysisToolSet.activeCumulativeSummaryIsLoading,
        pricingAnalysisToolSet.activeCumulativeSummary,
    ]);
    return { chartData };
};
export default useDollarsLostByPricingConcernSummary;
